export default __webpack_public_path__ + "static/media/emc-3.e3ffeadb.png";